/* ═══════════════════════════════════════════════════════════════════
   DG Sidebar JS — Collapse, sub-menus, keyboard nav
   ThemeDGCore | Distribution Gauthier
   ═══════════════════════════════════════════════════════════════════ */
(function () {
    'use strict';

    /* ── DOM refs ── */
    var sidebar = document.getElementById('dg-sidebar');
    var overlay = document.getElementById('dg-sidebar-overlay');

    if (!sidebar) return;

    /* ─────────────────────────────────────────────────────────────────
       OPEN / CLOSE — used by openSidebar() / closeSidebar()
       in dg.js — we patch those globals so they work with our overlay
       ───────────────────────────────────────────────────────────────── */
    var _origOpen = window.openSidebar;
    var _origClose = window.closeSidebar;

    window.openSidebar = function () {
        sidebar.classList.add('is-open');
        if (overlay) {
            overlay.style.display = 'block';
            requestAnimationFrame(function () {
                overlay.classList.add('is-visible');
            });
        }
        if(window.innerWidth <= 1024) {
            document.body.style.overflow = 'hidden';
        }
        if (typeof _origOpen === 'function') _origOpen();
    };

    window.closeSidebar = function () {
        sidebar.classList.remove('is-open');
        if (overlay) {
            overlay.classList.remove('is-visible');
            setTimeout(function () { overlay.style.display = 'none'; }, 240);
        }
        document.body.style.overflow = '';
        if (typeof _origClose === 'function') _origClose();
    };

    window.toggleSidebar = function () {
        if(sidebar.classList.contains('is-open')) {
            window.closeSidebar();
        } else {
            window.openSidebar();
        }
    };

    /* Click on overlay closes sidebar (Mobile) */
    if (overlay) {
        overlay.addEventListener('click', window.closeSidebar);
    }

    /* Click outside closes sidebar (Desktop & Mobile fallback) */
    document.addEventListener('click', function(e) {
        // If sidebar is NOT open, don't do anything
        if (!sidebar.classList.contains('is-open')) return;
        
        // Ignore clicks inside the sidebar itself
        if (sidebar.contains(e.target)) return;
        
        // Ignore clicks on the hamburger button (it has its own toggle logic)
        var hamburger = e.target.closest('.dg-hamburger');
        if (hamburger) return;

        // Close it!
        window.closeSidebar();
    });

    /* ─────────────────────────────────────────────────────────────────
       SUB-MENUS (accordion)
       Selector matches both data-sidebar-toggle (button) and links with subs
       ───────────────────────────────────────────────────────────────── */
    var parentLinks = sidebar.querySelectorAll('[data-sidebar-toggle]');


    parentLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
            if (sidebar.classList.contains('dg-sidebar--collapsed') && !sidebar.matches(':hover')) return;

            e.preventDefault();
            var sub = link.parentElement.querySelector('.dg-sidebar__sub');
            if (!sub) return;

            var isOpen = sub.classList.contains('is-open');

            /* Close all others */
            sidebar.querySelectorAll('.dg-sidebar__sub.is-open').forEach(function (el) {
                el.classList.remove('is-open');
                var parentLink = el.parentElement.querySelector('.dg-sidebar__link');
                if (parentLink) parentLink.setAttribute('aria-expanded', 'false');
            });

            if (!isOpen) {
                sub.classList.add('is-open');
                link.setAttribute('aria-expanded', 'true');
            } else {
                link.setAttribute('aria-expanded', 'false');
            }
        });
    });

    /* ─────────────────────────────────────────────────────────────────
       KEYBOARD: Escape closes mobile drawer
       ───────────────────────────────────────────────────────────────── */
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sidebar.classList.contains('is-open')) {
            window.closeSidebar();
        }
    });

})();
